// extracted by mini-css-extract-plugin
export var divider = "_te-0";
export var systemMessage = "_te-1";